export default __webpack_public_path__ + "static/media/shopping-bag.70721b27.svg";